module.exports = __webpack_public_path__ + "img/wb_slide_2.2534b86a.jpg";